import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { map, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var ManageForeclosureAuctionService = /** @class */ (function () {
    function ManageForeclosureAuctionService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    ManageForeclosureAuctionService.prototype.getStates = function () {
        var _this = this;
        var api = _GlobalNS.api.allStates;
        var params = new HttpParams();
        return this._http.get("" + api, { params: params })
            .pipe(map(function (response) { return _this.formatState(response); }), catchError(function (error) { return throwError(error); }));
    };
    ManageForeclosureAuctionService.prototype.formatState = function (response) {
        var data = response.data;
        var states = [];
        var tempArray = {};
        data.map(function (items) {
            tempArray = {
                label: items.StateName,
                value: items.StateCode,
                StateName: items.StateName,
                StateCode: items.StateCode
            };
            states.push(tempArray);
        });
        return states;
    };
    ManageForeclosureAuctionService.prototype.getCounty = function (stateCode) {
        var api = _GlobalNS.api.county;
        var params = new HttpParams();
        params = params.set('StateCode', stateCode);
        return this._http.get("" + api, { params: params });
    };
    ManageForeclosureAuctionService.prototype.getForeclosureAuctionLocationData = function (searchParams) {
        var api = _GlobalNS.api.foreclosureAuctionLocation.search;
        var params = new HttpParams();
        params = params.set('state', searchParams.State)
            .set('county', searchParams.County)
            .set('locationAddress', searchParams.LocationAddress)
            .set('locationDetails', searchParams.LocationDetails)
            .set('statutaryLocation', searchParams.StatutaryLocation)
            .delete('state', '')
            .delete('county', '')
            .delete('locationAddress', '')
            .delete('locationDetails', '')
            .delete('statutaryLocation', '');
        return this._http.get("" + api, { params: params });
    };
    ManageForeclosureAuctionService.prototype.save = function (params) {
        var api = _GlobalNS.api.foreclosureAuctionLocation.create;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, params, this.httpOptions);
    };
    ManageForeclosureAuctionService.prototype.update = function (params) {
        var api = _GlobalNS.api.foreclosureAuctionLocation.update;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, params, this.httpOptions);
    };
    ManageForeclosureAuctionService.prototype.delete = function (matrixIds) {
        var api = _GlobalNS.api.foreclosureAuctionLocation.delete;
        var params = new HttpParams();
        params = params.set('FcMatrixID', matrixIds);
        return this._http.get("" + api, { params: params });
    };
    ManageForeclosureAuctionService.prototype.getSelectorsData = function () {
        var api = _GlobalNS.api.foreclosureAuctionLocation.changeLogSelectors;
        return this._http.get("" + api);
    };
    ManageForeclosureAuctionService.prototype.getChangeLogData = function (changeLogParams) {
        var api = _GlobalNS.api.foreclosureAuctionLocation.changeLog;
        var params = new HttpParams();
        params = params.set('StateCode', changeLogParams.StateCode)
            .set('ChangedBy', changeLogParams.ChangedBy)
            .set('County', changeLogParams.County)
            .set('FromDate', changeLogParams.FromDate)
            .set('ToDate', changeLogParams.ToDate)
            .delete('ChangedBy', '')
            .delete('County', '')
            .delete('FromDate', '')
            .delete('ToDate', '')
            .delete('StateCode', '');
        return this._http.get("" + api, { params: params });
    };
    ManageForeclosureAuctionService.ngInjectableDef = i0.defineInjectable({ factory: function ManageForeclosureAuctionService_Factory() { return new ManageForeclosureAuctionService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: ManageForeclosureAuctionService, providedIn: "root" });
    return ManageForeclosureAuctionService;
}());
export { ManageForeclosureAuctionService };
